import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDesktop = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7152_73461)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M22.3994 4.51074C22.9516 4.51074 23.3992 4.95863 23.3994 5.51074V16.8887C23.3993 17.4409 22.9516 17.8887 22.3994 17.8887H1.59961C1.04746 17.8886 0.599691 17.4408 0.599609 16.8887V5.51074C0.599809 4.95869 1.04754 4.51085 1.59961 4.51074H22.3994ZM1.59961 16.8887H6.39941V5.51074H1.59961V16.8887ZM7.2002 5.51074V16.8887H16.7998V5.51074H7.2002ZM17.5996 10.8447H22.3994V5.51074H17.5996V10.8447ZM22.3994 11.5557H17.5996V16.8887H22.3994V11.5557Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M22.3994 17.1001L22.498 17.1099C22.594 17.1291 22.6827 17.1764 22.7529 17.2466L23.5537 18.0464C23.6966 18.1893 23.7393 18.4046 23.6621 18.5913C23.5848 18.778 23.4023 18.8997 23.2002 18.8999H0.799805C0.597574 18.8999 0.415281 18.7781 0.337891 18.5913C0.260558 18.4045 0.303316 18.1894 0.446289 18.0464L1.24609 17.2466C1.33982 17.1529 1.46707 17.1001 1.59961 17.1001H22.3994Z",
			stroke: "currentColor",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7152_73461",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}) })]
});
export default SvgDesktop;
